import React from 'react';
import _Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Card } from '@material-ui/core';
import { Alert } from 'reactstrap';
// const useStyles = makeStyles(theme => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: '#fff',
//   },
// }));




export default class Backdrop extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
        this.count = 0;
        Backdrop.current = this;
    }

    show(msg) {
        ++this.count;
        if (this.count === 1) {
            this.setState({ open: true, message: msg || "请稍候" });
        }
        
        // if (this.count === 0) {
        //     this.setState({ open: true, message: msg || "请稍候" });
        //     return;
        // }
        // this.count++;
    }

    hide() {
        --this.count;
        if (this.count <= 0) {
            this.setState({ open: false });
            return;
        }
        if (this.count < 0) this.count = 0;
        
        // if (this.count === 0) {
        //     this.setState({ open: false });
        //     return;
        // }
        // this.count--;
        // if (this.count < 0) this.count = 0;
    }

    render() {
        let { open, message } = this.state;
        let { style } = this.props;
        return (
            <_Backdrop

                style={{ zIndex: 99999, backgroundColor: "rgba(0, 0, 0, 0)", ...style }}
                open={open}
            >
                <Loading message={message} />
            </_Backdrop>
        )
    }
}

export class Loading extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        let { message } = this.props;
        return (
            <div className="row no-gutters">
                <Alert className="alert-addon-card bg-info text-white shadow-lg mb-0">
                    <span className="icon-addon alert-addon">
                        <CircularProgress color="inherit" size={30} thickness={4} />
                    </span>
                    <span className="d-inline-block" style={{ fontSize: "1rem" }}>{message}</span>
                </Alert>
            </div>)
    }
}


export class LoadingSlim extends React.Component {

    constructor(props) {
        super(props);
    }

    getConfig(){
        let {size} = this.props;
        switch(size){
            case "sm" : return {circularSize:40,fontSize:"c-text-s2"};
            case "xs" : return {circularSize:20,fontSize:"c-text-s1"};
        }
    }

    render() {
        let { message,className,align } = this.props;
        let config = this.getConfig();
        return (
            <div className={`d-flex flex-row justify-content-${align} align-items-center ${className}`}>
                <div className={`d-flex flex-column justify-content-center align-items-center`}>
                    <CircularProgress color="secondary" size={config.circularSize} thickness={3} />
                </div>
                {message?<p className={`mb-0 ${config.fontSize} c-text-deep-grey ml-3`}>{message}</p>:null}
            </div>
            )
    }
}

LoadingSlim.defaultProps={
    message:"加载中",
    size:"sm",
    className:'',
    align:"center"
}